import { useState, useRef, useEffect } from 'react'
import { convertToCsvString, downloadExcel } from '../extra/helpers'
import { DataBridgeExportProps } from './../extra/types'

import CloudDownloadIcon from '@mui/icons-material/CloudDownload'
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown'

/**
 * @typedef {import('zod/mini').infer<DataBridgeExportProps>} _DataBridgeExportProps
 * @type {React.FC<_DataBridgeExportProps>}
 */
export const DataBridgeExport = (_props) => {
  const {
    text = 'エクスポート',
    filename = 'Sample',
    getRecords: getData,
    disabled,
    className,
    onExport,
    onError,
    ...props
  } = DataBridgeExportProps.parse(_props)

  const [isMenuOpen, setIsMenuOpen] = useState(false)
  const menuRef = useRef(null)
  const buttonRef = useRef(null)

  // メニュー外クリックで閉じる
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        menuRef.current &&
        !menuRef.current.contains(event.target) &&
        buttonRef.current &&
        !buttonRef.current.contains(event.target)
      ) {
        setIsMenuOpen(false)
      }
    }

    if (isMenuOpen) {
      document.addEventListener('mousedown', handleClickOutside)
    }

    return () => {
      document.removeEventListener('mousedown', handleClickOutside)
    }
  }, [isMenuOpen])

  const handleExportCsv = async () => {
    try {
      const records = getData()
      const result = convertToCsvString(records)
      onExport(result, `${filename}.csv`)
      setIsMenuOpen(false)
    } catch (error) {
      console.error(error)
      onError?.('エラーが発生しました')
      setIsMenuOpen(false)
    }
  }

  const handleExportExcel = async () => {
    try {
      const records = getData()
      const excelFilename = `${filename}.xlsx`
      await downloadExcel(excelFilename, records)
      setIsMenuOpen(false)
    } catch (error) {
      console.error(error)
      onError?.('エラーが発生しました')
      setIsMenuOpen(false)
    }
  }

  return (
    <div className="relative">
      <button
        ref={buttonRef}
        disabled={disabled}
        data-testid={props?.['data-testid']}
        type="button"
        className={
          `rounded-lg bg-white border-[#383947] border h-[45px] items-center ` +
          ` text-sm text-[#383947b3] px-4 py-2 inline-flex gap-2` +
          ` ${!disabled && 'hover:text-[#383947] hover:font-medium hover:border-1.5 hover:border-[#383947]'} ` +
          ` ${disabled && 'bg-gray-300/40'} ${className}`
        }
        onClick={() => !disabled && setIsMenuOpen(!isMenuOpen)}
      >
        <CloudDownloadIcon fontSize="small" />
        {text}
        <ArrowDropDownIcon fontSize="small" />
      </button>

      {isMenuOpen && (
        <div
          ref={menuRef}
          className="absolute right-0 mt-1 w-48 bg-white border border-gray-300 rounded-lg shadow-lg z-50"
        >
          <button
            type="button"
            className="w-full text-left px-4 py-2 text-sm text-[#383947b3] hover:bg-gray-100 first:rounded-t-lg"
            onClick={handleExportCsv}
          >
            CSV形式
          </button>
          <button
            type="button"
            className="w-full text-left px-4 py-2 text-sm text-[#383947b3] hover:bg-gray-100 last:rounded-b-lg"
            onClick={handleExportExcel}
          >
            Excel形式
          </button>
        </div>
      )}
    </div>
  )
}
